import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as uuid from 'uuid';
import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, NgControl } from '@angular/forms';

@Component({
	selector: 'app-checkbox-input',
	templateUrl: './checkbox-input.component.html',
	providers: [
		{
			provide: [],
			useExisting: forwardRef(() => CheckboxInputComponent),
			multi: true,
		},
	],
})
export class CheckboxInputComponent implements OnInit, OnDestroy, ControlValueAccessor {
	@Input() label?: string;
	@Input() name?: string;
	@Input() value?: string;
	@Input() orientation?: string;

	private componentDestroyed$: Subject<boolean> = new Subject<boolean>();

	public disabled = false;
	public uuid = uuid.v4();
	public control: UntypedFormControl = new UntypedFormControl(null);
	public updateValue = (_: any) => {};
	public onTouched = () => {};

	constructor(public ngControl: NgControl) {
		ngControl.valueAccessor = this;
	}

	private propagateChange(value: any): void {
		if (this.updateValue) {
			return this.updateValue(value);
		}

		if (this.control) {
			this.control.setValue(value, {
				emitEvent: false
			});
		}
	}

	public ngOnInit(): void {
		this.control.valueChanges
			.pipe(takeUntil(this.componentDestroyed$))
			.subscribe((value) => {
				this.onTouched();
				this.propagateChange(value);
			});
	}

	public ngOnDestroy(): void {
		this.componentDestroyed$.next(true);
		this.componentDestroyed$.complete();
	}

	public writeValue(value: any): void {
		setTimeout(() => this.control.setValue(value, {
			emitEvent: false
		}));
	}

	public registerOnChange(fn: any): void {
		this.updateValue = fn;
	}

	public registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	public setDisabledState(isDisabled: boolean): void {
		this.disabled = isDisabled;
		isDisabled
			? this.control.disable({ emitEvent: false })
			: this.control.enable({ emitEvent: false });
	}
}
